import React, { useState } from "react";

import { faBars } from "@fortawesome/sharp-regular-svg-icons/faBars";
import { faTimes } from "@fortawesome/sharp-regular-svg-icons/faTimes";
import Dialog from "@radix-ui/react-dialog";
import clsx from "clsx";

import { themeBackgroundWhite } from "~styles/themes/theme.background_white.css";

import { Box } from "~components/Box";
import { IconFontAwesome } from "~components/IconFontAwesome";

import { type MobileFooter, type NavCategory } from "~sections/Nav/Nav.types";
import { Categories } from "~sections/Nav/mobile/_Categories";

import TrueLayerLogo from "~assets/svg/logo/truelayer_logo.svg";

import { Footer } from "./_Footer";
import * as styles from "./styles.css";

interface NavMobileProps extends MobileFooter {
  navCategories: NavCategory[];
  mobileBackLabel: string;
  /* a11y */
  ariaLabelOpenMainNav: string;
  ariaLabelCloseMainNav: string;
  ariaLabelBackToMainNav: string;
}

export function NavMobile({
  buttonLink,
  buttonText,
  secondaryButtonLink,
  secondaryButtonText,
  navCategories,
  mobileBackLabel,
  ariaLabelCloseMainNav,
  ariaLabelBackToMainNav,
  ariaLabelOpenMainNav,
}: NavMobileProps): JSX.Element {
  const [openMainNav, setOpenMainNav] = useState(false);

  return (
    <Dialog.Root open={openMainNav} onOpenChange={setOpenMainNav}>
      <Dialog.Trigger asChild className={styles.dialogTrigger}>
        <button
          type="button"
          aria-label={ariaLabelOpenMainNav}
          className={styles.navButton}
        >
          <IconFontAwesome
            size="lg"
            icon={faBars}
            title={ariaLabelOpenMainNav}
          />
        </button>
      </Dialog.Trigger>
      <Dialog.Portal>
        <Dialog.Overlay className={styles.dialogOverlay} />
        <Dialog.Content
          className={clsx(styles.dialogContent, themeBackgroundWhite)}
        >
          <Box className={styles.dialogHeader}>
            <Dialog.Title className={styles.dialogTitle}>
              <TrueLayerLogo className={styles.logo} />
            </Dialog.Title>
            <Dialog.Close asChild>
              <button type="button" aria-label={ariaLabelCloseMainNav}>
                <IconFontAwesome size="lg" icon={faTimes} />
              </button>
            </Dialog.Close>
          </Box>
          <Box className={styles.dialogScrollableContent}>
            {navCategories.map((navCategory) => {
              return (
                <Categories
                  navCategory={navCategory}
                  buttonText={buttonText}
                  buttonLink={buttonLink}
                  secondaryButtonText={secondaryButtonText}
                  secondaryButtonLink={secondaryButtonLink}
                  closeMainNav={() => setOpenMainNav(false)}
                  ariaLabelCloseMainNav={ariaLabelCloseMainNav}
                  ariaLabelBackToMainNav={ariaLabelBackToMainNav}
                  mobileBackLabel={mobileBackLabel}
                />
              );
            })}
          </Box>
          <Box className={styles.dialogFooter}>
            <Footer
              buttonText={buttonText}
              buttonLink={buttonLink}
              secondaryButtonText={secondaryButtonText}
              secondaryButtonLink={secondaryButtonLink}
            />
          </Box>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
}
